// extracted by mini-css-extract-plugin
export default {"head":"Products_head__lwg96","title":"Products_title__IZljT","products":"Products_products__Feopz","wrapper":"Products_wrapper__Ft0+g","empty":"Products_empty__X0Bd4"};